// src/components/modal/ModalMessage.js
import React from 'react';
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo } from 'react-icons/fi';
import ModalContainer from '../modalForm/ModalContainer';
import ModalHeader from '../modalForm/ModalHeader';
import ModalBody from '../modalForm/ModalBody';
import ModalFooter from '../modalForm/ModalFooter';
import ModalActions, { ModalActionButton } from '../modalForm/ModalActions';
import './ModalMsgYesNo.css';
import './ModalMessage.css';

const ModalMessage = ({ show, onClose, message, type = 'info', largura = '500px' }) => {
  // Função para processar a mensagem e adicionar quebras de linha
  const renderMessage = (msg) => {
    if (typeof msg !== 'string') {
      return msg; // Se não for string (ex.: JSX), retorna diretamente
    }
    return msg.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < msg.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  // Definindo estilos e textos baseados no tipo
  const modalStyles = {
    info: { title: 'Informação', icon: FiInfo, className: 'modal-feedback-info' },
    warning: { title: 'Atenção', icon: FiAlertTriangle, className: 'modal-feedback-warning' },
    danger: { title: 'Erro', icon: FiAlertCircle, className: 'modal-feedback-danger' },
    success: { title: 'Sucesso', icon: FiCheckCircle, className: 'modal-feedback-success' },
  };

  // Obter os estilos e textos para o tipo atual
  const { title, icon, className } = modalStyles[type] || modalStyles.info;

  // Adicionei onClose como dependência
  // O ModalContainer mantém o fechamento atualizado e controla o foco e o Escape.
  return (
    <ModalContainer
      show={show}
      onHide={onClose}
      largura={largura} // limita o tamanho máximo (ex: 500px)
      zIndex={2000}
      variant="cadastro"
      contentClassName={`modal-feedback modal-message ${className}`}
    >
      <ModalHeader title={title} icon={icon} onHide={onClose} />
      <ModalBody>
        <div className="modal-feedback-message">{renderMessage(message)}</div>
      </ModalBody>
      <ModalFooter>
        <ModalActions>
          <ModalActionButton action="close" onClick={onClose} data-modal-autofocus="true">Fechar</ModalActionButton>
        </ModalActions>
      </ModalFooter>
    </ModalContainer>
  );
};

export default ModalMessage;
